import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SweetAlertService from "../../../services/SweetAlertService";
import EmployerService from "../Services/EmployerService";
import './Employer.css'

interface Employer {
    id: number;
    employerName: number;
    hoursPerWeek: boolean;
    minutesPerWeek: any;
    sessionPerWeek: any;
    lastActivityEntry: string
}
export const Employers = () => {
    const [archivedEmployersList, setArchivedEmployersList] = useState<Employer[]>([]);
    const [unArchivedEmployersList, setUnArchivedEmployersList] = useState<Employer[]>([]);
    const navigate = useNavigate();
    const [employersCount, setEmployersCount] = useState(0);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        EmployerService.getEmployers()
            .then((response) => {
                if (response.data) {
                    let archievedEmployersList = response.data.filter((x: { isArchived: boolean; }) => x.isArchived == true);
                    let unArchievedEmployersList = response.data.filter((x: { isArchived: boolean; }) => x.isArchived == false);
                    setArchivedEmployersList(archievedEmployersList);
                    setUnArchivedEmployersList(unArchievedEmployersList);
                    setEmployersCount(response.data.length);
                }
            });
    }

    //Archive employer
    const ArchiveEmployer = (id: any) => {
        SweetAlertService.confirmCustom("Archive", "You will not able to add new activities to the diary for these employment details. You will still be able to create reports for activities already in the diary.", "Archive", "Cancel").then((res) => {
            if (res.isConfirmed) {
                var data = { memberEmployerId: id };
                EmployerService.archiveEmployer(data).then((res) => {
                    if (res) {
                        SweetAlertService.success('Success', "Employer archived successfully");
                        fetchData();
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        })
    }

    //Unarchive employer
    const UnArchiveEmployer = (id: any) => {
        SweetAlertService.confirmCustom("Unarchive", "Are you sure you want to unarchive this employer?", "Unarchive employer", "Cancel").then((res) => {
            if (res.isConfirmed) {
                var data = { memberEmployerId: id };
                EmployerService.unArchiveEmployer(data).then((res) => {
                    if (res) {
                        SweetAlertService.success('Success', "Employer unarchived successfully");
                        fetchData();
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.Id[0]);
                })
            }
        })
    }

    //Delete employer
    const DeleteEmployer = (id: any) => {
        SweetAlertService.confirmCustom("Delete", "Are you sure you would like to delete?", "Continue", "Cancel").then((res) => {
            if (res.isConfirmed) {
                EmployerService.deleteEmployer(id).then((res) => {
                    if (res) {
                        SweetAlertService.success('Success', "Employer deleted successfully");
                        fetchData();
                        if (employersCount <= 1) {
                            window.location.reload()
                        }
                    }
                }).catch((error) => {
                    SweetAlertService.error('Error', error.response.data.errors.MemberEmployerId[0]);
                })
            }
        })
    }

    return (
        <>
            <main>
                <div className="hero-banner hero-banner--background hero-banner--subpage">
                    <div className="container">
                        <div>
                            <div className="my-4">
                                <h1>Your employment details</h1>
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            {
                                                unArchivedEmployersList.length > 0 && <div>
                                                    <p>If your contract changes,or you have multiple employer/contracts, <Link className="my-link" to="/addemployers"><u>add new employment details</u></Link>.</p>
                                                    <table className="custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th className="custom-th">Employment details</th>
                                                                <th className="custom-th">Sessions/week</th>
                                                                <th className="custom-th">Time/week</th>
                                                                <th className="custom-th">Diary last modified</th>
                                                                <th className="custom-th">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {unArchivedEmployersList.map((employer) => (
                                                                <tr key={employer.employerName}>
                                                                    <td className="custom-td" hidden>{employer.id}</td>
                                                                    <td className="custom-td">{employer.employerName}</td>
                                                                    <td className="custom-td">{employer.sessionPerWeek}</td>
                                                                    <td className="custom-td">{employer.hoursPerWeek + " hrs " + employer.minutesPerWeek + " mins"}</td>
                                                                    <td className="custom-td">{employer.lastActivityEntry ? moment(employer.lastActivityEntry).format("DD/MM/YYYY") : "No activities in diary"}</td>
                                                                    <td className="custom-td">
                                                                        <Link to="/employerlist" className="btn btn-primary customBtn" onClick={() => ArchiveEmployer(employer.id)}>Archive</Link> &nbsp;
                                                                        <Link to="/employerlist" className="btn btn-secondary deleteBtn ms-1" onClick={() => DeleteEmployer(employer.id)}>
                                                                            <i className="bi bi-trash-fill"></i>
                                                                        </Link>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                            {
                                                unArchivedEmployersList.length < 1 && <div className="table-responsive-xl mb-4">
                                                    <p>You currently have no active employment details.</p>
                                                    <p><Link className="my-link" to="/addemployers"><u>Add new employment details</u></Link> so you can add activities into your diary.</p>&nbsp;
                                                </div>
                                            }
                                        </div>
                                        {
                                            archivedEmployersList.length > 0 && <div className="my-4">
                                                <h1>Archived employment details</h1>
                                                <div className="col-sm-12">
                                                    <p>You cannot add new activities into the diary for the following employment details. You can continue to run reports on activities already entered into the diary.</p>
                                                    <div className="table-responsive-xl">
                                                        <table className="custom-table">
                                                            <thead>
                                                                <tr>
                                                                    <th className="custom-th">Employment details</th>
                                                                    <th className="custom-th">Sessions/week</th>
                                                                    <th className="custom-th">Time/week</th>
                                                                    <th className="custom-th">Diary last modified</th>
                                                                    <th className="custom-th">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {archivedEmployersList.map((employer) => (
                                                                    <tr key={employer.employerName}>
                                                                        <td className="custom-td" hidden>{employer.id}</td>
                                                                        <td className="custom-td">{employer.employerName}</td>
                                                                        <td className="custom-td">{employer.sessionPerWeek}</td>
                                                                        <td className="custom-td">{employer.hoursPerWeek + " hrs " + employer.minutesPerWeek + " mins"}</td>
                                                                        <td className="custom-td">{employer.lastActivityEntry ? moment(employer.lastActivityEntry).format("DD/MM/YYYY") : "No activities in diary"}</td>
                                                                        <td className="custom-td">
                                                                            <Link to="/employerlist" className="btn btn-primary customBtn" onClick={() => UnArchiveEmployer(employer.id)}>Unarchive</Link> &nbsp;
                                                                            <Link to="/employerlist" className="btn btn-secondary deleteBtn ms-1" onClick={() => DeleteEmployer(employer.id)}>
                                                                                <i className="bi bi-trash-fill"></i>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}
